import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A promise that resolves to an instance of `}<inlineCode parentName="p">{`IRedirectPaymentMethodManager`}</inlineCode>{` or `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
    <Group summary='IRedirectPaymentMethodManager' mdxType="Group">
	<Item title='start' subtitle='() => Promise<void>' mdxType="Item">
		Start the redirect payment flow.
	</Item>
	<Item title='addEventListener' subtitle='(event: EventTypes, callback: EventListener) => void' mdxType="Item">
		Add an event listener to the button.
		<Group mdxType="Group">
			<Item title='EventTypes' subtitle='"blur" | "change" | "click" | "close" | "error" | "focus"' mdxType="Item"></Item>
			<Item title='EventListener' subtitle='(event?: Event) => void' mdxType="Item"></Item>
		</Group>
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      